import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import moment from "moment";

import { config } from "../../../config/index";
import { to12Hr, toWeekStartDate } from "../../../helpers/moment";
import ToastUtil from "../../../components/ToastNotification/ToastUtil";
import AlertService from "../../../components/SweetAlert";
const { API_URL } = config;

const ShiftPreference = ({
  activeClient,
  setUpdateTime,
  activeDate,
  weekSchedules,
  activeSite,
  siteShifts,
  preferredShifts,
}) => {
  const token = localStorage.getItem("token");
  /**
   * State
   */

  const [selectedShifts, setSelectedShifts] = useState([]);
  const [isNotAvailable, setIsNotAvailable] = useState(false);
  const [remarks, setRemarks] = useState("");

  useEffect(() => {
    const isNotAvailableData = preferredShifts.some(
      (preference) => preference.is_available === false
    );

    if (isNotAvailableData) {
      const preference = preferredShifts.find(
        (preference) => preference.is_available === false
      );
      setIsNotAvailable(isNotAvailableData);
      setRemarks(preference.remarks);
    } else {
      setIsNotAvailable(false);
      setRemarks(null);
    }
  }, [preferredShifts, activeDate]);

  /**
   * Helper Functions
   */
  const isSelected = (shift_id) => selectedShifts.some((id) => id === shift_id);
  const togglePreferenceBtn = (shift_id) =>
    isSelected(shift_id) ? removeSelected(shift_id) : addSelected(shift_id);
  // const disablePreferenceBtn = shift_id => preferredShifts.some(preference => preference.shift_id === shift_id) ? true : false

  const addSelected = (shift_id) => {
    let clone = JSON.parse(JSON.stringify(selectedShifts));
    clone.push(shift_id);
    setSelectedShifts(clone);
  };

  const removeSelected = (shift_id) => {
    let clone = JSON.parse(JSON.stringify(selectedShifts));
    let filtered = clone.filter((id) => id !== shift_id);
    setSelectedShifts(filtered);
  };

  const submitShiftPreference = async () => {
    if (
      await AlertService.confirm("", `Are you sure you want to update your shift preference on ${moment(
          activeDate
        ).format("DD/MM/YYYY")}?`)
    ) {
      let url = `${API_URL}/associate/sites/${activeSite}/setPreference`;

      try {
        let data = {
          date: moment(activeDate).format("YYYY-MM-DD"),
          shifts: isNotAvailable
            ? siteShifts.map((shift) => shift.id)
            : selectedShifts,
          is_available: !isNotAvailable,
          remarks: remarks,
        };

        let response = await fetch(url, {
          method: "POST",
          body: JSON.stringify(data),
          withCredentials: true,
          mode: "cors",
          headers: {
            Authorization: token,
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
          },
        });

        if (response.ok) {
          ToastUtil.success("Shift preference updated!");
          setUpdateTime(moment());
          setIsNotAvailable(false);
          setSelectedShifts([]);
        } else {
          ToastUtil.error("Failed to set new shift preference!");
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const getPreferredShifts = () => {
    return preferredShifts.filter((shifts) =>
      siteShifts
        .filter((shift) => shift.status == 1)
        .some((siteSchedule) => shifts.shift_id === siteSchedule.id)
    );
  };

  /**
   * Render
   */
  return (
    <div className="container py-2">
      <div className="shadow-sm border-0 rounded preffered-shift-container bg-white">
        <div className="container pb-2">
          <h6 className="py-2">Your Preferred Shift</h6>
          {getPreferredShifts().length > 0 ? (
            getPreferredShifts().find(
              (preference) => !preference.is_available
            ) ? (
              <button className="btn btn-danger btn-block py-1 text-left rounded">
                Not Available {remarks && `(${remarks})`}
              </button>
            ) : (
              getPreferredShifts().map(
                (preference) =>
                  preference.is_available && (
                    <button
                      key={preference.id}
                      className="btn btn-danger btn-block py-1 text-left rounded"
                    >
                      {`${
                        preference.shift.name ? preference.shift.name : "Shift"
                      } (${to12Hr(preference.shift.start_time)} - ${to12Hr(
                        preference.shift.end_time
                      )})`}
                    </button>
                  )
              )
            )
          ) : (
            <div className="py-1">None</div>
          )}
          {activeClient && weekSchedules && (
            <React.Fragment>
              <h6 className="py-2">Reselect Shifts</h6>
              {siteShifts
                .filter((shift) => shift.status == 1)
                .map((shift) => (
                  <button
                    key={shift.id}
                    className={
                      "btn btn-light btn-block py-1 text-left rounded" +
                      (isSelected(shift.id) ? " btn-dark" : "")
                    }
                    disabled={isNotAvailable}
                    // disabled={disablePreferenceBtn(shift.id)}
                    onClick={() => togglePreferenceBtn(shift.id)}
                  >
                    {`${shift.name ? shift.name : "Shift"} (${to12Hr(
                      shift.start_time
                    )} - ${to12Hr(shift.end_time)})`}
                  </button>
                ))}
              <h6 className="pt-3">
                <label className="d-flex align-items-center">
                  <input
                    type="checkbox"
                    className="mr-2"
                    checked={isNotAvailable}
                    onChange={() => {
                      setIsNotAvailable(!isNotAvailable);
                      setSelectedShifts([]);
                    }}
                  />
                  Not Available
                </label>
              </h6>
              {isNotAvailable && (
                <textarea
                  className="form-control"
                  placeholder="Remarks"
                  cols="30"
                  rows="5"
                  value={remarks}
                  onChange={(e) => setRemarks(e.target.value)}
                />
              )}
              <button
                disabled={selectedShifts.length === 0 && !isNotAvailable}
                className="btn btn-light btn-block mt-4 rounded"
                onClick={() => submitShiftPreference()}
              >
                Confirm shift
              </button>
            </React.Fragment>
          )}
        </div>
      </div>
    </div>
  );
};

export default withRouter(ShiftPreference);
